module.exports = __webpack_public_path__ + "img/wails.a39103c3.jpg";